import templateStr from 'text!./BaseCoverages.html';

export default {
    restrict: 'E',
    bindings: {
        lobCode: '&',
        coverageData: '<'
    },
    template: templateStr,
    controller: function controller() {}
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/LobOfferingSelection/BaseCoverages/BaseCoverages.js
// module id = 1219
// module chunks = 0